export const keyMappings = {
   KeyZ: -21,
   KeyS: -20,
   KeyX: -19,
   KeyD: -18,
   KeyC: -17,
   KeyV: -16,
   KeyG: -15,
   KeyB: -14,
   KeyH: -13,
   KeyN: -12,
   KeyJ: -11,
   KeyM: -10,
   KeyQ: -9,
   Digit2: -8,
   KeyW: -7,
   Digit3: -6,
   KeyE: -5,
   KeyR: -4,
   Digit5: -3,
   KeyT: -2,
   Digit6: -1,
   KeyY: 0,
   Digit7: 1,
   KeyU: 2,
   KeyI: 3,
};
